import React from 'react';
import '../styles/Legal.css';
import usePageMeta from "../hooks/usePageMeta";

const LAST_UPDATED = 'January 9, 2026';

const TermsPage: React.FC = () => {
  usePageMeta({
    title: "Terms of Service | PabSync",
    description:
      "The terms that govern your access to and use of PabSync.",
    path: "/terms",
  });

  return (
    <div className="legal-page">
      <main className="legal-container">
        <article className="legal-card">
          <h1 className="legal-title">Terms of Service</h1>
          <p className="legal-meta">Last updated: {LAST_UPDATED}</p>

          <p>
            These Terms govern your access to and use of PabSync (the “Service”), including our website and
            application. By using the Service, you agree to these Terms.
          </p>

          <h2>Accounts</h2>
          <ul>
            <li>You’re responsible for activities that happen under your account.</li>
            <li>You must provide accurate information and keep it up to date.</li>
            <li>Keep your credentials secure and notify us of suspected unauthorized access.</li>
          </ul>

          <h2>Acceptable use</h2>
          <ul>
            <li>Don’t misuse the Service or interfere with its operation.</li>
            <li>Don’t attempt to access accounts, data, or systems you aren’t authorized to access.</li>
            <li>Don’t upload malicious code or content that violates applicable law.</li>
          </ul>

          <h2>Paid plans and billing</h2>
          <p>
            If you purchase a paid plan, you agree to pay applicable fees and taxes. Pricing and plan details are
            available on our <a href="/pricing">Pricing</a> page.
          </p>

          <h2>Content</h2>
          <p>
            You retain ownership of content you submit to the Service. You grant PabSync a limited license to host,
            store, and display your content solely to provide the Service.
          </p>

          <h2>Intellectual property</h2>
          <p>
            The Service (including the website, application, and associated materials) is owned by PabSync and is
            protected by intellectual property laws.
          </p>

          <h2>Third-party services</h2>
          <p>
            Some features rely on third-party services (for example: payments, email delivery, and security tooling).
            See our <a href="/subprocessors">Subprocessors</a> page for common vendors.
          </p>

          <h2>Termination</h2>
          <p>
            You may stop using the Service at any time. We may suspend or terminate access if you violate these Terms
            or if needed to protect the Service.
          </p>

          <h2>Disclaimers</h2>
          <p>
            The Service is provided “as is” and “as available”. To the maximum extent permitted by law, PabSync
            disclaims warranties of merchantability, fitness for a particular purpose, and non-infringement.
          </p>

          <h2>Privacy</h2>
          <p>
            Our <a href="/privacy">Privacy Statement</a> explains how we handle personal information.
          </p>

          <h2>Contact</h2>
          <p>
            Questions about these Terms: <a href="mailto:datacare@pabsync.com">datacare@pabsync.com</a>
          </p>

          <p className="legal-note">
            This page is provided for general informational purposes and may be updated from time to time.
          </p>
        </article>
      </main>
    </div>
  );
};

export default TermsPage;
